import * as AddressingConstActionTypes from '../actionTypes/AddressingConstActionTypes';

export const getCityStateByZipCode = (zipCode) => ({
    type: AddressingConstActionTypes.GET_ADDRESSING_ZIP_CODE,
    payload: zipCode,
});

export default getCityStateByZipCode;
